import {
	ADD_WIDGET,
	UPDATE_WIDGET,
	SET_WIDGETS,
	DELETE_WIDGET
} from "../../actions/DashboardDesigner/actionContants";

const widgets = (state = [], action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type:
		 *  widget:
		 * }
		 */
		case ADD_WIDGET:
			return [...state, action.widget];
		/**
		 * action: {
		 *  type:
		 *  payload:
		 *  widgetId:
		 * }
		 */
		case UPDATE_WIDGET:
			var { widgetId, payload } = action;
			let targetWidgetObj = state.find(e => e.id === widgetId);
			let updatedWidgetObj = { ...targetWidgetObj, ...payload };
			return state.map(widget => {
				if (widget.id === widgetId) {
					return updatedWidgetObj;
				} else {
					return { ...widget };
				}
			});
		/**
		 * action: {
		 *  widgetId:
		 * }
		 */
		case DELETE_WIDGET:
			var { widgetId } = action;
			return state.filter(widget => widget.id !== widgetId);
		case SET_WIDGETS:
			return action.data;
		default:
			return state;
	}
};

export default widgets;
